<ion-item [button]="button" [detail]="detail" [lines]="lines" (click)="onItemClick()">
  @if (showThumbnailImage) {
    <ion-thumbnail slot="start" class="session-thumbnail">
      <ion-img
        [src]="thumbnailUrl!"
        (ionError)="onThumbnailError()"
        (ionImgDidLoad)="$event.target.classList.add('loaded')"
        class="thumbnail-image"
      ></ion-img>
    </ion-thumbnail>
  } @else {
    <ion-icon slot="start" name="stopwatch-outline" class="session-fallback-icon"></ion-icon>
  }
  <ion-label>
    <h2>{{ sessionName }}</h2>
  </ion-label>
</ion-item>
